import { render, staticRenderFns } from "./AlumnosAdminView.vue?vue&type=template&id=5dae822e&scoped=true&"
import script from "./AlumnosAdminView.vue?vue&type=script&lang=js&"
export * from "./AlumnosAdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae822e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
